<template>
  <div>
    <!-- <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语"/>
    </el-form-item> -->
    <el-form-item label="仅允许拍照上传" label-width="120px">
      <el-switch v-model="_format"></el-switch>
    </el-form-item>
    <el-form-item label="拍照时增加水印" label-width="120px">
      <el-switch v-model="_option"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "AmountInputConfig",
  components: {},
  props: {
    format: {
      type: String,
      default: "false",
    },
    option: {
      type: String,
      default: "false",
    },
  },
  computed: {
    _format: {
      get() {
        return this.format === "true" ? true : false;
      },
      set(val) {
        this.$emit("update:format", val === true ? "true" : "false");
      },
    },
    _option: {
      get() {
        return this.option === "true" ? true : false;
      },
      set(val) {
        // console.log(val)
        this.$emit("update:option", val === true ? "true" : "false");
      },
    },
  },
};
</script>

<style scoped>
</style>
